"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContact = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importDefault(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var json = __importStar(require("./localization.json"));

var PageContact = function PageContact(_a) {
  var language = _a.language,
      pageOrigin = _a.pageOrigin,
      theme = _a.theme;
  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage(language);
  console.debug(pageOrigin);
  /*
  const localizedTexts = {
    formButtonSend:
      localizedStrings.sharedContent.pages.pageContact.formButtonSend,
    formCity: localizedStrings.sharedContent.pages.pageContact.formCity,
    formCityPlaceholder:
      localizedStrings.sharedContent.pages.pageContact.formCityPlaceholder,
    formEmail: localizedStrings.sharedContent.pages.pageContact.formEmail,
    formEmailPlaceholder:
      localizedStrings.sharedContent.pages.pageContact.formEmailPlaceholder,
    formFirstname:
      localizedStrings.sharedContent.pages.pageContact.formFirstname,
    formFirstnamePlaceholder:
      localizedStrings.sharedContent.pages.pageContact.formFirstnamePlaceholder,
    formMessage: localizedStrings.sharedContent.pages.pageContact.formMessage,
    formMessagePlaceholder:
      localizedStrings.sharedContent.pages.pageContact.formMessagePlaceholder,
    formNumber: localizedStrings.sharedContent.pages.pageContact.formNumber,
    formNumberPlaceholder:
      localizedStrings.sharedContent.pages.pageContact.formNumberPlaceholder,
    formPostcode: localizedStrings.sharedContent.pages.pageContact.formPostcode,
    formPostcodePlaceholder:
      localizedStrings.sharedContent.pages.pageContact.formPostcodePlaceholder,
    formReason: localizedStrings.sharedContent.pages.pageContact.formReason,
    formStreet: localizedStrings.sharedContent.pages.pageContact.formStreet,
    formStreetPlaceholder:
      localizedStrings.sharedContent.pages.pageContact.formStreetPlaceholder,
    formSurname: localizedStrings.sharedContent.pages.pageContact.formSurname,
    formSurnamePlaceholder:
      localizedStrings.sharedContent.pages.pageContact.formSurnamePlaceholder,
    leadText: localizedStrings.sharedContent.pages.pageContact.leadText,
    legendPerson: localizedStrings.sharedContent.pages.pageContact.legendPerson,
    legendReason: localizedStrings.sharedContent.pages.pageContact.legendReason,
    sentEmailText:
      localizedStrings.sharedContent.pages.pageContact.sentEmailText,
    sentEmailTitle:
      localizedStrings.sharedContent.pages.pageContact.sentEmailTitle,
    subTitle: localizedStrings.sharedContent.pages.pageContact.subTitle,
    title: localizedStrings.sharedContent.pages.pageContact.title,
  };
  */

  return react_1["default"].createElement(basic_frontend_common_1.ContainerArticle, {
    theme: theme
  }, react_1["default"].createElement(basic_frontend_common_1.Intro, {
    title: localizedStrings.sharedContent.pages.pageContact.title,
    subTitle: localizedStrings.sharedContent.pages.pageContact.subTitle,
    lead: localizedStrings.sharedContent.pages.pageContact.leadText,
    theme: theme,
    containerContent: true
  }), react_1["default"].createElement(basic_frontend_common_1.ContainerCover, {
    theme: theme
  }, react_1["default"].createElement("span", {
    className: "flex flex-col items-center w-20 mx-auto bg-transparent text-center mt-8 mb-8"
  }, react_1["default"].createElement(basic_frontend_common_1.ButtonRegular, {
    text: "Formular",
    size: basic_frontend_common_1.ButtonSize.normal,
    type: basic_frontend_common_1.ButtonType.secondary,
    onClick: function onClick() {
      return (0, basic_frontend_common_1.openWindow)('https://forms.office.com/r/6RHbjM5Tvz');
    }
  }))), react_1["default"].createElement(basic_frontend_common_1.Spacer, null));
};

exports.PageContact = PageContact;